import type { ChatMessage, ChatSession, DirectoryMap, GroupMap } from '@domain/chat/types';

export type EventMap = {
  'SessionUpdateEvent': ChatSession[];
  'NewMsgEvent': ChatMessage;
  'HistoryGapFilledEvent': string; // sessionKey
  'ContactsUpdateEvent': { contacts: DirectoryMap; groups: GroupMap };
};

type EventKey = keyof EventMap;

class EventBus {
  private listeners: { [K in EventKey]?: Array<(payload: EventMap[K]) => void> } = {};

  on<K extends EventKey>(event: K, callback: (payload: EventMap[K]) => void) {
    if (!this.listeners[event]) {
      this.listeners[event] = [];
    }
    // Type coercion here to simplify the internal storage logic
    (this.listeners[event] as any).push(callback);
    return () => this.off(event, callback);
  }

  off<K extends EventKey>(event: K, callback: (payload: EventMap[K]) => void) {
    if (!this.listeners[event]) return;
    this.listeners[event] = (this.listeners[event] as any).filter((cb: any) => cb !== callback);
  }

  emit<K extends EventKey>(event: K, payload: EventMap[K]) {
    if (!this.listeners[event]) return;
    this.listeners[event]!.forEach(cb => {
      try {
        (cb as any)(payload);
      } catch (e) {
        console.error(`[EventBus] Error in ${event} listener:`, e);
      }
    });
  }
}

export const eventBus = new EventBus();
